var _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    fill: "url(#paint0_linear_4213_20887)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    stroke: "url(#paint1_linear_4213_20887)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4224 5.90414H11.3182V4.89205C11.3182 4.46965 10.9746 4.12598 10.5522 4.12598H4.99583C4.38268 4.12598 3.87715 4.59496 3.81879 5.19303C3.80988 5.23529 3.81305 4.85873 3.81305 10.6911C3.81305 11.3433 4.34363 11.8739 4.99581 11.8739H11.4224C11.8448 11.8739 12.1885 11.5302 12.1885 11.1078V6.67021C12.1885 6.24781 11.8449 5.90414 11.4224 5.90414ZM4.99583 4.65218H10.5522C10.6844 4.65218 10.792 4.75979 10.792 4.89206V5.90416H4.99583C4.64405 5.90416 4.35608 5.62605 4.34003 5.27817C4.35606 4.93028 4.64404 4.65218 4.99583 4.65218ZM11.4224 11.3477H4.99583C4.63379 11.3477 4.33926 11.0532 4.33926 10.6911V6.23094C4.52722 6.35685 4.75309 6.43033 4.99583 6.43033H11.4224C11.5547 6.43033 11.6623 6.53794 11.6623 6.67021V7.73684H9.68239C9.00809 7.73684 8.4595 8.28541 8.4595 8.95971C8.4595 9.634 9.00809 10.1826 9.68239 10.1826H11.6623V11.1078C11.6623 11.2401 11.5547 11.3477 11.4224 11.3477ZM11.6623 9.6564H9.68239C9.29824 9.6564 8.9857 9.34387 8.9857 8.95972C8.9857 8.57557 9.29822 8.26304 9.68239 8.26304H11.6623V9.6564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77949 9.34101C9.99007 9.34101 10.1608 9.1703 10.1608 8.95972C10.1608 8.74914 9.99007 8.57843 9.77949 8.57843C9.56891 8.57843 9.3982 8.74914 9.3982 8.95972C9.3982 9.1703 9.56891 9.34101 9.77949 9.34101Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4213_20887",
    x1: 11.8889,
    y1: -0.313725,
    x2: 11.8889,
    y2: 15.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2570AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4213_20887",
    x1: 8.05555,
    y1: -0.313725,
    x2: 8.05555,
    y2: 16.6275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81CDF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.d556b39459cf2823aa6e61338a7da105.svg";
export { ForwardRef as ReactComponent };